import { Component, OnInit, inject, DestroyRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthService } from '../../../core/service/auth/auth.service';
import { NoFederationComponent } from '../no-federation/no-federation.component';
import { InvalidFederationComponent } from '../invalid-federation/invalid-federation.component';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-federation-shell',
  standalone: false,
  template: `
    @switch (state()) {
      @case ('loading') { <div class="flex items-center justify-center min-h-screen">Chargement...</div> }
      @case ('valid')   { <router-outlet></router-outlet> }
      @case ('invalid') { <app-invalid-federation [slug]="federationSlug" /> }
      @case ('no-federation') { <app-no-federation /> }
      @case ('module-off') {
        <div class="flex items-center justify-center min-h-screen bg-gray-50 p-4">
          <div role="alert" class="bg-white rounded-2xl shadow-lg p-6 sm:p-8 w-full max-w-md text-center">
            <div class="flex items-center justify-center w-16 h-16 bg-amber-100 text-amber-600 rounded-full mx-auto mb-6 text-3xl">!</div>
            <h1 class="text-xl font-bold text-gray-800">Module non activé</h1>
            <p class="mt-2 text-sm text-gray-500">Ce module n'est pas activé pour votre fédération. Contactez l'administrateur de la plateforme.</p>
          </div>
        </div>
      }
    }
  `,
  styles: []
})
export class FederationShellComponent implements OnInit {
  private httpClient = inject(HttpClient);
  private authService = inject(AuthService);
  private destroyRef = inject(DestroyRef);

  state = signal<'loading' | 'valid' | 'invalid' | 'no-federation' | 'module-off'>('loading');
  federationSlug = this.authService.federationSlug;

  ngOnInit(): void {
    if (!this.federationSlug) {
      this.state.set('no-federation');
      return;
    }

    this.httpClient.get<{ success: boolean; logo_url?: string; module_enabled?: boolean }>(`${environment.apiUrl}/api/federations/resolve?slug=${encodeURIComponent(this.federationSlug)}`)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res) => {
          this.authService.setSlugLogoUrl(res.logo_url ?? null);
          this.state.set(res.module_enabled === false ? 'module-off' : 'valid');
        },
        error: () => this.state.set('invalid'),
      });
  }
}
